import { useTranslation } from 'react-i18next';
import Page from '@/components/Page';
import PriceBox from '@/components/PriceBox';

const Prices = () => {
  const { t } = useTranslation();

  return (
    <Page
      title={t('pages.prices.title')}
    >
      <PriceBox
        title={t('pages.prices.box.full.title')}
        content={t('pages.prices.box.full.content')}
        price={t('pages.prices.box.full.price')}
      />

      <PriceBox
        title={t('pages.prices.box.risk.title')}
        content={t('pages.prices.box.risk.content')}
        price={t('pages.prices.box.risk.price')}
      />

      <PriceBox
        title={t('pages.prices.box.retire.title')}
        content={t('pages.prices.box.retire.content')}
        price={t('pages.prices.box.retire.price')}
      />

      <PriceBox
        title={t('pages.prices.box.escort.title')}
        content={t('pages.prices.box.escort.content')}
        price={t('pages.prices.box.escort.price')}
      />

      <PriceBox
        title={t('pages.prices.box.once.title')}
        content={t('pages.prices.box.once.content')}
        price={t('pages.prices.box.once.price')}
      />

      <PriceBox
        title={t('pages.prices.box.home.title')}
        content={t('pages.prices.box.home.content')}
        price={t('pages.prices.box.home.price')}
      />

      <PriceBox
        title={t('pages.prices.box.office.title')}
        content={t('pages.prices.box.office.content')}
        price={t('pages.prices.box.office.price')}
      />

      <PriceBox
        title={t('pages.prices.box.year.title')}
        content={t('pages.prices.box.year.content')}
        price={t('pages.prices.box.year.price')}
      />

      <PriceBox
        title={t('pages.prices.box.subscription.title')}
        content={t('pages.prices.box.subscription.content')}
        price={t('pages.prices.box.subscription.price')}
      />

      <PriceBox
        title={t('pages.prices.box.external.title')}
        content={t('pages.prices.box.external.content')}
        price={t('pages.prices.box.external.price')}
      />
    </Page>
  );
};

export default Prices;
